// Copyright (c) Docugami, Inc. All rights reserved.

import { BatchUploadEvent, BatchUploadStatus, FileUploaderInstance, FileUploadEvent, IUploadStats } from "filemanager/FileUploader";
import { useState } from "react";
import { useEventListener } from "./EventListener";

export interface IUploadProgress {
    isUploading: boolean;
    uploadStats: IUploadStats;
}

export function useUploadProgress(): IUploadProgress {
    const [stats, setStats] = useState(FileUploaderInstance.stats);
    const [isUploading, setIsUploading] = useState(FileUploaderInstance.stats.totalCount > 0);

    useEventListener<FileUploadEvent>(FileUploaderInstance.onFileUpload, onUploadStatusChanged);
    useEventListener<BatchUploadEvent>(FileUploaderInstance.onBatchUpload, onBatchUploadEvent);

    function onUploadStatusChanged() {
        setStats(FileUploaderInstance.stats);
    }

    function onBatchUploadEvent(event: BatchUploadEvent) {
        setIsUploading(event.status === BatchUploadStatus.Running);
        if (event.status === BatchUploadStatus.None) {
            setStats(FileUploaderInstance.stats)
        }
    }

    return {
        isUploading: isUploading,
        uploadStats: stats
    }
}
